import { render } from "./ReviewCarousel.vue?vue&type=template&id=0a33f9fe&scoped=true"
import script from "./ReviewCarousel.vue?vue&type=script&lang=js"
export * from "./ReviewCarousel.vue?vue&type=script&lang=js"

import "./ReviewCarousel.vue?vue&type=style&index=0&id=0a33f9fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a33f9fe"]])

export default __exports__